/**
 * Dummy assistant call — replace with real backend once available.
 *
 * Contract the backend should implement:
 * POST /api/chatbot/ask
 * {
 *   messages: [{ role: "system"|"user"|"assistant", content: string }],
 *   context: { topic?: "monitoring"|"audit"|"llm-insights" }
 * }
 * Response:
 * { answer: string, suggestedQuestions?: string[] }
 */
import axios from "axios";

const baseUrl =  process.env.REACT_APP_BASE_URL;

export const askBrandAssistant = async (
  messages,
  execution_date,
  brand,
  abortController,
  userId,
  brandContext,
  phase,
  conversationId
) => {
  const lastUserMessage =
    [...messages].reverse().find((msg) => msg.role === "user")?.content || "";

  try {
    console.log("User_ID:", userId);
    const response = await axios.post(
      `${baseUrl}/metrics/chat`,
      {
        prompt: lastUserMessage,
        user_id: userId,
        execution_date: execution_date,
        brand: brand,
        brandContext,
        phase,
        conversationId,
      },
      {
        signal: abortController?.signal,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = response.data;
    console.log("Chat API response data:", data, response);
    return data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message ||
        error?.message ||
        "Chat API request failed"
    );
  }

  // Simulate latency and return a deterministic mock answer.
  // await new Promise((resolve, reject) => {
  //   const timer = setTimeout(resolve, 750);
  //   abortController?.signal?.addEventListener("abort", () => {
  //     clearTimeout(timer);
  //     reject(new Error("Request aborted"));
  //   });
  // });

  // return (
  //   `Here's a preview answer about "${lastUserMessage || "your brand"}". ` +
  //   "Once the chatbot API is live, this will return data-grounded insights for monitoring, audit/discovery, and LLM insights."
  // );
};

export const updatedChatContext = async (userId, brand) => {
  try {
    //const baseUrl = `process.env.REACT_APP_BASE_URL` ||  process.env.REACT_APP_BASE_URL;
    const response = await axios.post(
      `${baseUrl}/metrics/update-chat-context`,
      {
        user_id: userId,
        brand
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    console.log("Chat API response:", response.data);
    return response.data;
  } catch (error) {
    console.error("updatedChatContext error:", error);
    throw new Error(
      error?.response?.data?.message ||
        error?.message ||
        "Chat API request failed"
    );
  }
};

export const getUniqueBrands = async (userId) => {
  try {
    //const baseUrl = `process.env.REACT_APP_BASE_URL` ||  process.env.REACT_APP_BASE_URL;
    const response = await axios.post(
      `${baseUrl}/metrics/get-unique-brands`,
      {
        user_id: userId,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    console.log("Chat API response:", response.data);
    return response.data;
  } catch (error) {
    console.error("getUniqueBrands error:", error);
    throw new Error(
      error?.response?.data?.message ||
        error?.message ||
        "Chat API request failed"
    );
  }
};
